export enum MESSAGE_STATUS {
  RECEIVED = "received",
  DELIVERED = "delivered",
  SENT = "sent",
  SCHEDULED = "scheduled",
  FAILED = "failed",
  REJECTED = "rejected",
  IGNORED = "ignored",
}

export enum EmgStatus {
  Delivered = 1,
  InProcess = 2,
  Failed = 3,
  Deleted = 4,
  Expired = 5,
  Rejected = 6,
  Canceled = 7,
  Queued = 8,
  Orphaned = 9,
  Relayed = 10,
  Unknown = 11,
}

export const MESSAGE_STATUS_NAME: Record<MESSAGE_STATUS, string> = {
  [MESSAGE_STATUS.RECEIVED]: "Recibido",
  [MESSAGE_STATUS.DELIVERED]: "Entregado",
  [MESSAGE_STATUS.SCHEDULED]: "Programado",
  [MESSAGE_STATUS.SENT]: "Enviado",
  [MESSAGE_STATUS.FAILED]: "Fallido",
  [MESSAGE_STATUS.REJECTED]: "Rechazado",
  [MESSAGE_STATUS.IGNORED]: "Ignorado",
};

export const MESSAGE_STATUS_ICON: Record<MESSAGE_STATUS, string> = {
  [MESSAGE_STATUS.RECEIVED]: "upload",
  [MESSAGE_STATUS.DELIVERED]: "check",
  [MESSAGE_STATUS.SCHEDULED]: "calendar",
  [MESSAGE_STATUS.FAILED]: "alert-octagon",
  [MESSAGE_STATUS.REJECTED]: "alert-octagon",
  [MESSAGE_STATUS.SENT]: "send",
  [MESSAGE_STATUS.IGNORED]: "alert-octagon",
};

export const MESSAGE_STATUS_COLOR: Record<MESSAGE_STATUS, string> = {
  [MESSAGE_STATUS.RECEIVED]: "primary",
  [MESSAGE_STATUS.DELIVERED]: "primary",
  [MESSAGE_STATUS.SCHEDULED]: "warning",
  [MESSAGE_STATUS.FAILED]: "danger",
  [MESSAGE_STATUS.REJECTED]: "warning",
  [MESSAGE_STATUS.IGNORED]: "warning",
  [MESSAGE_STATUS.SENT]: "success",
};
